export default __webpack_public_path__ + "static/media/Ch2d.001b9e78.gif";